import React from 'react';
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Nav } from 'react-bootstrap'
import { useEffect } from "react";
import { addItem } from './store.js'
import { useDispatch } from 'react-redux'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import "./Detail.css";
import product_data from "./ProductData"


function Detail(props) {

    let { id } = useParams();

    let [tap, setTap] = useState(0);

    let [fade2, setFade2] = useState('')
    useEffect(() => {
        window.scrollTo(0, 0)
        setFade2('end')
        return () => {
            setFade2('')
        }
    }, [])

    let selproduct = props.all.find((x) => x.id == id);
    let dispatch = useDispatch();

    let [nogada] = useState(product_data);



    return (
        <div className={'container start ' + fade2}>

            <div className="D_ptoduct">
                <div className="D_productLeft">
                    <img src={selproduct.imgurl} />
                </div>

                <div className="D_productRight">
                    <div className='D_brandbox'>
                        <img src="/img/detail_icon_hous.png" />
                        <p>{selproduct.brand}</p>
                    </div>

                    <div className='D_titlebox'>
                        <p>{selproduct.title}</p>
                        <img src="/img/detail_icon_share.png" />
                        <img src="/img/detail_icon_heart.png" />
                    </div>

                    <div className='D_price'>
                        <p>{selproduct.persent}</p>
                        <p>{selproduct.price + '원'}</p>
                        <p>{selproduct.saleprice + '원'}</p>
                    </div>

                    <div className='D_benefit'>
                        <span>로그인하고 혜택가 확인하기</span>
                        <img src="/img/detail_icon_arrow.png"></img>
                    </div>

                    <div className='D_mileage'>
                        <img src="/img/detail_icon_M.png" />
                        <span><b>최대 3,30M</b> 적립예정</span>
                    </div>

                    <div className='D_shipping'>
                        <div className='shipping_left'>
                            <img src="/img/detail_icon_car.png" />
                        </div>
                        <div className='shipping_right'>
                            <ul>
                                <li><img src="/img/detail_icon_LFshoong.png" />
                                    <span>지금 결제시 <b>오늘출발</b></span>
                                </li>
                                <li>
                                    <span className='shipping_day'>06/24(토)</span>
                                    <span className='shipping_probability'>이내 도착확률 84%</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className='D_LFcard'>
                        <img src="/img/detail_icon_LFcard.png" />
                        <span>LF PayLFmall 신용카드 결제시 <b>5% 추가할인</b></span>
                    </div>

                    <div className='D_LFpay'>
                        <img src="/img/detail_icon_card.png" />
                        <img src="/img/detail_icon_lfpay.png" />
                        <span>신한카드 최대 20,000원 즉시할인 외 3건 / 카드별 무이자</span>
                    </div>

                    <div className='D_map'>
                        <img src="/img/detail_icon_map.png" />
                        <span>구매가능한 매장</span>
                    </div>

                    <Button
                        variant="primary"
                        onClick={() => {
                            //  dispatch(addItem(  {id : 2,  imgurl : 'shoes1.jpg', name : 'Grey Yordan', count : 1}))

                            dispatch(
                                addItem({
                                    id: selproduct.id,
                                    imgurl: selproduct.imgurl.replace("img/", ""),
                                    name: selproduct.title,
                                    count: 1,
                                })
                            );
                        }}
                        style={{ marginRight: "10px" }}
                    >
                        주문하기
                    </Button>

                    <Link to="/cart">
                        <Button variant="outline-success"> 주문상품 확인하기 </Button>
                    </Link>
                </div>
            </div>



            <Nav variant="tabs" defaultActiveKey="link0">
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(0) }} eventKey="link0">상세정보</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(1) }} eventKey="link1">반품/교환안내</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link onClick={() => { setTap(2) }} eventKey="link2">배송</Nav.Link>
                </Nav.Item>
            </Nav>

            <TabContent tap={tap} nogada={nogada} />
        </div>
    )
}



function TabContent({ tap, nogada }) {
    let { id } = useParams();

    let [fade, setFade] = useState('')
    useEffect(() => {
        setTimeout(() => { setFade('end') }, 10)
        return () => {
            setFade('')
        }
    }, [tap])

    return (
        //상세이미지 페이지
        <div className={'start ' + fade}>
            {[<div className='detail_img'>
                <img src={nogada[id].imgurl0} />
                <img src={nogada[id].imgurl1} />
                <img src={nogada[id].imgurl2} />
                <img src={nogada[id].imgurl3} />
                <img src={nogada[id].imgurl4} />
            </div>,

        //반품/교환 페이지
            <div className='detail_return'>
                <h3>반품/교환안내</h3>
                <table>
                    <tr>
                        <th>교환/반품신청</th>
                        <td>
                            마이페이지 - 주문/배송조회 화면에서 가능합니다.<br />
                            <b>[교환/반품 신청하러가기]</b>
                        </td>
                    </tr>
                    <tr>
                        <th>교환/반품 신청기간</th>
                        <td>
                        ▪ 단순변심 등 구매자 귀책인 경우 상품 수령 후 7일 이내만 가능합니다.<br/>
                        ▪ 불량, 오배송 등 당사 귀책으로 인한 과실 발생 시 수령 후 3개월 이내 (발견시점부터 30일 이내) 가능합니다.<br/>
                        </td>
                    </tr>
                    <tr>
                        <th>교환/반품 배송비</th>
                        <td>
                        <img src="/img/table.jpg" /><br/>
                        ▪ 구매자 귀책사유로 반품하는 경우 결제한 배송비는 환불되지 않으며, 무료배송으로 받은 상품 반품 시에는 왕복 배송비가 부과됩니다.<br/>
                        ▪ 제주/도서산간지역은 추가운임이 발생할 수 있습니다.<br/>
                        ▪ 부분 반품 시 남은 금액이 무료배송 기준이하일 경우 구매 시 배송비를 포함한 왕복 배송비가 부과됩니다.
                        </td>
                    </tr>
                    <tr>
                        <th>교환/반품 불가안내</th>
                        <td>
                        ▪ 상품 수령후 7일이 경과된 경우<br/>
                        ▪ 상품 TAG이 제거됐거나 상품박스 및 포장등이 훼손된 경우<br/>
                        ▪ 상품 사용, 소비로 상품가치가 현저히 감소한 경우<br/>
                        ▪ 복제가 가능한 상품의 포장을 훼손한 경우<br/>
                        </td>
                    </tr>
                    <tr>
                        <th>환불안내</th>
                        <td>
                        ▪ 신용카드: 카드사에 따라 4~5영업일 이내 취소<br/>
                        ▪ 무통장 입금 : 2~3영업일 이내 입력된 계좌로 환불<br/>
                        ▪ 상품 사용, 소비로 상품가치가 현저히 감소한 경우<br/>
                        ▪ 실시간 계좌이체: 2~3영업일 이내 이체된 결제 계좌로 환불<br/>
                        ▪ 휴대폰 소액결제: 2~4영업일 이내 환불<br/>
                        </td>
                    </tr>
                </table>
            </div>,

        //배송 페이지
            <div className='detail_shipping'>
                <h3>배송안내</h3>
                <table>
                    <tr>
                        <th>배송 기간</th>
                        <td>▪ 입점사가 직접 설정한 도착예정일로 상세정보에 공지된 배송일정을 참고해 주세요.<br/>
                        ▪ 입점사 및 택배사 상황에 따라 실제 도착일은 예측일과 다를 수 있습니다.
                        </td>
                    </tr>
                    <tr>
                        <th>배송비</th>
                        <td>▪ 무료</td>
                    </tr>
                </table>
            </div>][tap]}
        </div>
    )
}





export default Detail;